var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu-sublevel",class:_vm.customClasses},_vm._l((_vm.items),function(item){return _c('TheMenuSubitem',{key:item.text,attrs:{"content":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }